import { useState } from 'react';
import { format, parseISO } from 'date-fns';
import { CalendarDays } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Calendar } from '../ui/calendar';

// value / onChange use 'YYYY-MM-DD' strings.
export const DateField = ({ value, onChange, placeholder, testId }) => {
  const [open, setOpen] = useState(false);
  const selected = value ? parseISO(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="h-9 w-full flex items-center gap-2 px-2 border border-slate-200 rounded-md text-sm bg-white text-left hover:border-slate-300 transition-colors"
        >
          <CalendarDays className="w-4 h-4 text-slate-400 flex-shrink-0" />
          <span className={`truncate ${value ? 'text-slate-800' : 'text-slate-400'}`}>
            {selected ? format(selected, 'dd MMM yyyy') : placeholder}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 security-compact cal-pop" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => { onChange(d ? format(d, 'yyyy-MM-dd') : ''); setOpen(false); }}
          initialFocus
        />
        {value && (
          <button type="button" className="w-full text-xs text-slate-500 hover:text-red-600 py-2 border-t" onClick={() => { onChange(''); setOpen(false); }} data-testid={`${testId}-clear`}>
            Clear date
          </button>
        )}
      </PopoverContent>
    </Popover>
  );
};
